module.exports = __webpack_public_path__ + "img/sq-first.e550954e.png";